import "./Loading.css";

//import { FiCommand } from "react-icons/fi";
import { FaSpinner } from 'react-icons/fa';

export function LoadingIcon() {
  return (
      <FaSpinner className="loading-icon" />
  );
}